import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/ProductList.css';

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const isFetched = useRef(false);

  // Fetch product data once on component mount
  useEffect(() => {
    const fetchProducts = async () => {
      if (isFetched.current) return; // Prevent multiple fetches
      isFetched.current = true;

      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/product/all`);
        setProducts(response.data);
      } catch (error) {
        setError('There was an error fetching the products.');
        console.error(error);
      }
    };

    fetchProducts();
  }, []);

  // Navigate to product details page
  const handleProductClick = (id) => {
    navigate(`/product/${id}`);
  };

  // Render stars for averageRating
  const renderStars = (averageRating) => {
    const totalStars = 5;
    const filledStars = Math.floor(averageRating);
    const halfStar = averageRating - filledStars >= 0.5;
    const emptyStars = totalStars - filledStars - (halfStar ? 1 : 0);

    let stars = [];
    
    // Add filled stars
    for (let i = 0; i < filledStars; i++) {
      stars.push('★');
    }
    
    // Add half star if applicable
    if (halfStar) {
      stars.push('★');
    }
    
    // Add empty stars
    for (let i = 0; i < emptyStars; i++) {
      stars.push('☆');
    }

    return stars.join('');
  };

  if (error) {
    return <div style={{ color: 'red' }}>{error}</div>;
  }

  return (
    <div className="product-list-container">
      <h1>Featured Products</h1>
      <div className="product-list">
        {products.map((product) => {
          const discountedPrice =
            product.discount > 0
              ? (product.price - (product.price * product.discount) / 100).toFixed(2)
              : product.price.toFixed(2);

          const stars = renderStars(product.averageRating || 0);
          
          return (
            <div
              key={product.id}
              className="product-card"
              onClick={() => handleProductClick(product.id)}
            >
              <div className="image-container">
                {product.images && product.images.length > 0 ? (
                  <img
                    src={`/uploads/${product.images[0].imageUrl}`}
                    alt={product.name}
                    className="product-image"
                  />
                ) : (
                  <div className="no-image">No Image Available</div>
                )}
                {product.discount > 0 && (
                  <div className="discount-badge">-{product.discount}%</div>
                )}
              </div>

              <div className="product-info">
                <h2>{product.name}</h2>

                <p className="product-price">
                  ₹{discountedPrice}{' '}
                  {product.discount > 0 && (
                    <span className="original-price">₹{product.price}</span>
                  )}
                </p>

                {/* Render average rating stars */}
                <div className="rating-stars">
                  <span className="average-rating">{product.averageRating.toFixed(1)}</span> 
                  <span className="star-display">{stars}</span>
                  <span className="rating-count">({product.noOfRating || 0} ratings)</span>
                </div>

                <p className="product-description">{product.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductList;
